export type IsolatedPointsDisplay = (
	| {
			isolated?: [number, number | null][];
	  }
	| undefined
)[];

export const buildIsolatedPointsSeries = (
	processedData: { analogSeries: any[]; digitalSeries: any[] },
	displaySeries: {
		analog: IsolatedPointsDisplay;
		digital: IsolatedPointsDisplay;
	},
	useSeparateGrids: boolean,
	digitalStartIdx: number,
) => {
	const build = (
		list: any[],
		display: IsolatedPointsDisplay,
		xAxisIndex: number,
		yAxisOffset: number,
	) =>
		list.map((s, idx) => ({
			name: s.name,
			type: "scatter",
			xAxisIndex,
			yAxisIndex: yAxisOffset + idx,
			data: display[idx]?.isolated ?? [],
			symbol: "circle",
			symbolSize: 3,
			itemStyle: {
				color: s.color,
				borderWidth: 0,
			},
			emphasis: { disabled: true },
			legendHoverLink: false,
			z: 2,
			show: s.visible,
		}));

	return [
		...build(processedData.analogSeries, displaySeries.analog, 0, 0),
		...build(
			processedData.digitalSeries,
			displaySeries.digital,
			useSeparateGrids ? 1 : 0,
			digitalStartIdx,
		),
	];
};
